// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/modern/" + {"234":"index-page","328":"focus-visible","625":"map-page"}[chunkId] + "." + {"234":"7d0b4a8b","328":"dee405ab","625":"40126425"}[chunkId] + ".js";
};